<div class="flex flex-col min-h-screen">
  <app-header class="z-50 flex-grow-0"></app-header>
  <main class="flex flex-col flex-grow">
    <div class="sticky top-0 z-50 md:fixed md:right-0 md:bottom-0 md:top-auto">
      <app-chat *ngIf="brand.chatEnabled"></app-chat>
    </div>
    <div class="flex flex-col flex-grow mx-auto md:container">
      <div class="flex flex-col flex-grow align-middle">
        <div *ngIf="loading" class="flex flex-col items-center justify-center flex-grow">
          <img src="assets/loader/oval.svg" alt="Loader" />
        </div>
        <router-outlet *ngIf="!loading"></router-outlet>
      </div>
    </div>
  </main>
  <app-footer *ngIf="brand.footerVisible" [contactUsEmail]="brand.contactUsEmail" class="flex-grow-0"></app-footer>
</div>
